export const AcceptStatus = {
  DRAFT: {
    color: '66, 66, 66',
    name: 'Черновик',
  },
  PREACCEPT: {
    color: '255, 152, 0',
    name: 'На согласовании',
  },
  REWORK: {
    color: '33, 150, 243',
    name: 'На доработке',
  },
  ACCEPTED: {
    color: '76, 175, 80',
    name: 'Согласовано',
  },
  CANCELLED: {
    color: '176, 0, 32',
    name: 'Отменено',
  },
}
